import React from 'react';
import { identity } from 'ramda';

import { useIntl } from '@utils/intl';
import BaseBooking from '@views/Book/Book/BasicBook/Booking';
import { BaseBookProps } from '@views/shared/interfaces/booking';

import { useBook } from './hooks';

export default function Booking({
  date,
  enabledHalfDayBooking,
  enabledHourlyBooking,
  hasNextDaysBooking,
  type,
}: BaseBookProps) {
  const { t, formats } = useIntl();

  const {
    bookablePeriod,
    blockedTimeSlots,
    book,
    selectedSlots,
    error,
    errorBooking,
    loading,
    loadingBooking,
    setSlots,
    midDayHour,
    updateComment,
  } = useBook({
    date,
    enabledHalfDayBooking,
    enabledHourlyBooking,
    hasNextDaysBooking,
    formats,
    params: {},
    t,
    type,
  });

  return (
    <BaseBooking
      enabledHalfDayBooking={enabledHalfDayBooking}
      enabledHourlyBooking={enabledHourlyBooking}
      bookablePeriod={bookablePeriod}
      blockedTimeSlots={blockedTimeSlots}
      book={book}
      selectedSlots={selectedSlots}
      error={error}
      errorBooking={errorBooking}
      loading={loading}
      loadingBooking={loadingBooking}
      setSlots={setSlots}
      midDayHour={midDayHour}
      showAvailability={identity}
      updateComment={updateComment}
    />
  );
}
